import { INewsletter } from '../../models/Newsletters/INewsletter';
import HrDaily from './assets/hr-daily-updated.jpg';
import AllThingsWork from './assets/All Things Work.jpg';
import PeopleStratergy from './assets/People + Strategy Brief.jpg';
import AiHi from './assets/The AI+HI Project.jpg';
import Tomorrowist from './assets/Tomorrowist.jpg';

export function getNewsletters(): INewsletter[] {
  const newsletters: INewsletter[] = [
    {
      imageUrl: HrDaily,
      title: 'HR Daily',
      description: 'Stay up to date with the latest HR news, trends, and expert advice each business day.',
      buttonUrl: 'https://www.shrm.org/topics-tools/flagships/hr-daily',
    },
    {
      imageUrl: AllThingsWork,
      title: 'All Things Work',
      description: 'Stay ahead with deep dives into trends impacting the world of work.',
      buttonUrl: 'https://www.shrm.org/topics-tools/flagships/all-things-work',
    },
    {
      imageUrl: PeopleStratergy,
      title: 'People + Strategy Brief',
      description: 'Take a deep dive into the minds of influential executives impacting the workplace.',
      buttonUrl: 'https://www.shrm.org/topics-tools/flagships/people-strategy',
    },
    {
      imageUrl: AiHi,
      title: 'The AI+HI Project',
      description: 'Discover cutting-edge strategies to blend advanced technology with human intelligence.',
      buttonUrl: 'https://www.shrm.org/topics-tools/flagships/ai-hi',
    },
    {
      imageUrl: Tomorrowist,
      title: 'Tomorrowist',
      description: 'Explore the trends shaping tomorrow and prepare your workforce to meet those challenges today.',
      buttonUrl: 'https://www.shrm.org/topics-tools/flagships/tomorrowist',
    },
  ];

  return newsletters;
}
